<template functional>
    <vx-card class="px-4" :class="data.staticClass">
        <!-- MAIL HEAD -->
        <div class="vx-row">
            <div class="vx-col w-full border-b border-l-0 border-r-0 border-t-0 d-theme-border-grey-light border-solid flex justify-between flex items-center">

                <!-- Sender Details -->
                <div class="flex items-center">
                    <div>
                        <vs-avatar class="sender__avatar--single flex-shrink-0 mr-3 border-2 border-solid border-white"
                                   :src="props.model.img" size="65px"/>
                    </div>
                    <div class="flex flex-col">
                        <h5 class="mb-1">{{ props.model.title }}</h5>
                        <div class="flex items-center flex-col">
                            <span class="text-sm" v-if="props.model.sender">{{ props.model.sender.name }}</span>
                            <span class="text-sm">{{ props.model.created_at }}</span>
                        </div>
                    </div>
                </div>
                <!-- /Sender Details -->

                <!-- Mail Time & Date -->
                <div class="flex flex-col justify-end">
                    <span class="text-right">{{ props.model.time}}</span>
                    <div class="flex justify-end mt-2">
                        <span class="text-right">{{ props.model.time}}</span>
                    </div>
                </div>
            </div>
            <!-- /Mail Time & Date -->
        </div>

        <!-- MAIL CONTENT -->
        <div class="vx-row">
            <div class="vx-col w-full">
                <div class="mail__content break-words mt-8 mb-4" v-html="props.model.body"></div>
            </div>
        </div>
        <!-- MAIL ATTACHMENTS -->
        <div class="vx-row d-theme-border-grey-light border-solid border-t border-l-0 border-b-0 border-r-0 pt-3" v-if="props.model.files">
            <div class="flex ">
                <div class="mail__attachment" v-for="(attachment, index) in props.model.files" :key="index">
                    <a type="line" class="p-0 ml-3"  target="_blank" :href="props.home+attachment">
                        <div class="flex items-center justify-center">
                            <vs-icon size="small" icon="attachment"/>
                            <span class="mr-2">       فایل
                        {{ index+1 }}</span>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </vx-card>
</template>

<script>
    import themeConfig from '@/../themeConfig.js'

    export default {
        props: {
            model: {
                type: Object,
                required: true
            },
            home:{
                type:String,
                default:themeConfig.home('storage/')
            }
        }
    }
</script>
